module.exports = __webpack_public_path__ + "static/media/logo.27a976e7.png";